import { Button, Form, Col, DatePicker, Input, Row, Spin } from "antd";
import "./style.css";
import Cookies from "universal-cookie";
import { useState, useEffect, useRef } from "react";
import {
  url_get_list_interview,
  url_get_detail_interview,
  url_regis_interview,
  usersListURLV2,
  url_check_cv_interview,
} from "../../../constants";
import { authAxios } from "../../../utils";
import moment from "moment";
import { SearchOutlined } from "@ant-design/icons";
import FullCalendar from "@fullcalendar/react";
import dayGridPlugin from "@fullcalendar/daygrid";
import timeGridPlugin from "@fullcalendar/timegrid";
import viLocale from "@fullcalendar/core/locales/vi";
import interactionPlugin from "@fullcalendar/interaction";
import { openNotificationWithIcon } from "../../Function";
import ModalAddInterview from "./addInterview/index";
import { subtract } from "lodash";
import dayjs from "dayjs";

const { RangePicker } = DatePicker;
const cookies = new Cookies();
const rangeConfig = {
  rules: [
    {
      type: "array",
      required: true,
      message: "Vui lòng chọn thời gian!",
    },
  ],
};

const index = () => {
  const [form] = Form.useForm();
  const [dataInterview, setDataInterview] = useState([]);
  // const [dateSearch, setDateSearch] = useState([
  //   moment(new Date()).subtract(3, "months"),
  //   moment(new Date()).add(3, "months"),
  // ]);
  const [dateSearch, setDateSearch] = useState(moment(new Date()));
  const [loading, setLoading] = useState(false);
  const [isModalAddInterview, setIsModalAddInterview] = useState(false);
  const [dateTimeSelect, setDateTimeSelect] = useState({});
  const [typeModal, setTypeModal] = useState("");
  const [listUser, setListUser] = useState([]);
  const calendarRef = useRef(null);
  const appliedInterviewer = useRef();
  const listRequestId = useRef(0);

  const fetchListInterview = (params = {}) => {
    const requestId = ++listRequestId.current;
    setLoading(true);
    authAxios(cookies.get("token"))
      .get(url_get_list_interview, { params: params })
      .then((res) => {
        if (requestId !== listRequestId.current) return;
        const events = res.data.results.map((item) => {
          const startDateTime = `${item.start_date}T${item.time_start}`; // Kết hợp ngày và giờ
          const endDateTime = `${item.start_date}T${item.time_end}`;
          return {
            ...item,
            title_interview: item.title, // Gộp name và content
            title: `${item.user_create_name} - ${item.title}`, // Gộp name và content
            start: startDateTime,
            end: endDateTime,
          };
        });
        setDataInterview(events);
        setLoading(false);
      })
      .catch((err) => {
        if (requestId !== listRequestId.current) return;
        setLoading(false);
        if (err.response !== undefined) {
          if (err.response.status === 401) {
            window.location = "/login";
          }
        }
        console.log(err);
        if (err.hasOwnProperty("data")) {
          if (err.data.hasOwnProperty("message")) {
            openNotificationWithIcon("warn", err.data.message, "");
          }
        }
      });
  };

  const fetchListUserInfo = (params = {}) => {
    setLoading(true);
    authAxios(cookies.get("token"))
      .get(usersListURLV2, { params: params })
      .then((res) => {
        let data_user = res.data.filter((item) => item.is_active == true);
        setListUser(data_user);
        setLoading(false);
      })
      .catch((err) => {
        console.log(err);
        setLoading(false);
      });
  };

  useEffect(() => {
    form.setFieldsValue({
      datepicker: dateSearch,
    });
    fetchListUserInfo();
  }, []);

  const setRangeDate = (value) => {
    form.setFieldsValue({
      datepicker: moment(value, "DD/MM/YYYY"),
    });
  };
  const onFinish = (values) => {
    // Chức năng tìm kiếm
    setDateSearch(values.datepicker);
    form.setFieldsValue({
      datepicker: values.datepicker,
    });
    appliedInterviewer.current = values.user_interview?.trim() || undefined;
    // Dẫn lịch đến ngày đã chọn
    const calendarApi = calendarRef.current.getApi();
    const previousStart = calendarApi.view.activeStart.getTime();
    calendarApi.gotoDate(moment(values.datepicker, "DD/MM/YYYY").toDate()); // Chuyển lịch đến ngày được chọn
    // datesSet only runs when the visible range changes.
    if (previousStart === calendarApi.view.activeStart.getTime()) {
      fetchListInterview({
        from_date: moment(calendarApi.view.activeStart).format("YYYY-MM-DD"),
        to_date: moment(calendarApi.view.activeEnd).format("YYYY-MM-DD"),
        user_interview: appliedInterviewer.current,
      });
    }
  };

  const onChangeTime = (dateInfo) => {
    const calendarApi = calendarRef?.current?.getApi();
    fetchListInterview({
      from_date: moment(dateInfo.start).format("YYYY-MM-DD"),
      to_date: moment(dateInfo.end).format("YYYY-MM-DD"),
      user_interview: appliedInterviewer.current,
    });

    if (
      calendarApi?.currentData?.currentViewType === "timeGridWeek" ||
      calendarApi?.currentData?.currentViewType === "timeGridDay"
    ) {
      form.setFieldsValue({
        datepicker: moment(dateInfo.start),
      });
    } else if (calendarApi?.currentData?.currentViewType === "dayGridMonth") {
      form.setFieldsValue({
        datepicker: moment(dateInfo.view.currentStart),
      });
    } else {
    }
  };

  const handleChange = (get_date_setinterview = null) => {
    if (get_date_setinterview != null) {
      var value_search = get_date_setinterview;
    } else {
      var value_search = form.getFieldsValue();
      value_search = value_search.datepicker;
    }
    const calendarApi = calendarRef.current.getApi();
    calendarApi.gotoDate(moment(value_search, "DD/MM/YYYY").toDate()); // Chuyển lịch đến ngày được chọn
  };

  const handleOpenAddInterview = (info) => {
    // Dùng để tạo lịch cho các khung giờ chưa có lịch
    const clickedDate = moment(info.date); // Chuyển đổi thời gian click thành moment
    const currentDate = moment(); // Thời gian hiện tại
    if (clickedDate.isBefore(currentDate)) {
      openNotificationWithIcon(
        "warn",
        "Không thể chọn khung giờ trong quá khứ."
      );
      return;
    }
    setTypeModal("add");
    setDateTimeSelect(info);
    setIsModalAddInterview(true);
  };
  const onFinishAddInterview = (values) => {
    // Thêm lịch PV
    if (values.start_date != undefined) {
      var time_start_date = values.start_date;
      values["start_date"] = time_start_date.format("YYYY-MM-DD");
    }
    if (values.time_start != undefined) {
      values["time_start"] = values.time_start.format("HH:mm");
    }
    if (values.time_end != undefined) {
      values["time_end"] = values.time_end.format("HH:mm");
    }
    var FormData = require("form-data");
    var data = new FormData();
    data.append("values", JSON.stringify(values));

    // let get_form = form.getFieldsValue();
    authAxios(cookies.get("token"))
      .post(url_regis_interview, data)
      .then((res) => {
        openNotificationWithIcon(
          "success",
          "Tạo lịch phỏng vấn thành công.",
          ""
        );
        handleChange(time_start_date.format("DD/MM/YYYY"));
        setIsModalAddInterview(false);
      })
      .catch((err) => {
        console.log(err);
        if (err.response !== undefined) {
          if (err.response.status === 401) {
            window.location = "/login";
          }
        }
        if (err.hasOwnProperty("data")) {
          if (err.data.hasOwnProperty("message")) {
            openNotificationWithIcon("error", err.data.message, "");
          }
        }
      });
  };

  const handleOpenDetail = (info) => {
    setTypeModal("view");
    setDateTimeSelect(info);
    setIsModalAddInterview(true);
  };

  const onFinishDelete = (dataInterview) => {
    var time_start_date = dataInterview.event.start;
    authAxios(cookies.get("token"))
      .delete(
        url_get_detail_interview(dataInterview.event.extendedProps.id_interview)
      )
      .then((res) => {
        openNotificationWithIcon(
          "success",
          "Xóa lịch phỏng vấn thành công.",
          ""
        );
        handleChange(moment(time_start_date).format("DD/MM/YYYY"));
        setIsModalAddInterview(false);
      })
      .catch((err) => {
        console.log(err);
        if (err.response !== undefined) {
          if (err.response.status === 401) {
            window.location = "/login";
          }
        }
        if (err.hasOwnProperty("data")) {
          if (err.data.hasOwnProperty("message")) {
            openNotificationWithIcon("error", err.data.message, "");
          }
        }
      });
  };

  const onFinishEdit = (values) => {
    // Chức năng chỉnh sửa
    var FormData = require("form-data");
    var data = new FormData();
    if (dateTimeSelect.hasOwnProperty("event")) {
      values["id_interview"] = dateTimeSelect.event.extendedProps.id_interview;
    } else {
      values["id_interview"] = null;
    }
    if (!values.user_interview || values.user_interview.length == 0) {
      values["user_interview"] = undefined;
    }
    var time_start_date = values.start_date;
    data.append("values", JSON.stringify(values));
    authAxios(cookies.get("token"))
      .put(url_regis_interview, data)
      .then((res) => {
        openNotificationWithIcon("success", "Cập nhật lịch thành công.", "");
        setIsModalAddInterview(false);

        handleChange(time_start_date.format("DD/MM/YYYY"));
      })
      .catch((err) => {
        if (err.response !== undefined) {
          if (err.response.status === 401) {
            window.location = "/login";
          }
        }
        console.log(err);
        if (err.hasOwnProperty("data")) {
          if (err.data.hasOwnProperty("message")) {
            openNotificationWithIcon("warn", err.data.message, "");
          }
        }
      });
  };

  const fetchCheckCVInterview = (params = {}) => {
    authAxios(cookies.get("token"))
      .get(url_check_cv_interview(params))
      .then((res) => {
        if (res.data && res.data.code_interview) {
          window.open("/detail-interview/" + res.data.code_interview); // Mở liên kết mới
        }
      })
      .catch((err) => {
        if (err.response !== undefined) {
          if (err.response.status === 401) {
            window.location = "/login";
          }
        }
        console.log(err);
        if (err.hasOwnProperty("data")) {
          if (err.data.hasOwnProperty("message")) {
            openNotificationWithIcon("warn", err.data.message, "");
          }
        }
      });
  };

  const handleViewCVInterview = (data) => {
    // Xem CV của 1 lịch PV
    //  <a href={"/tickets/" + item.id}>{value}</a>
    fetchCheckCVInterview(data.event.extendedProps.id_interview);
  };

  return (
    <div className="custom-calendar">
      <Spin spinning={loading}>
        <Form
          form={form}
          layout="vertical"
          autoComplete="off"
          onFinish={onFinish}
          initialValues={{
            remember: true,
          }}
          className="form-search"
        >
          <Row className="cadidate-management-row">
            <Col span={5}>
              <Form.Item
                label="Thời gian"
                name="datepicker"
                className="cadidate-management-form-item"
              >
                <DatePicker
                  suffixIcon={null}
                  placeholder="DD/MM/YYYY"
                  format={"DD/MM/YYYY"}
                  onChange={(e, value) => {
                    setRangeDate(value);
                  }}
                  allowClear={false}
                />
              </Form.Item>
            </Col>
            <Col span={4}>
              <Form.Item
                label="Người phỏng vấn"
                name="user_interview"
                className="recruitment-requirements-form-item"
              >
                <Input placeholder="Nhập username"></Input>
              </Form.Item>
            </Col>
            <Col span={1} className="cadidate-management-span-2">
              <Form.Item label={" "}>
                <Button
                  type="primary"
                  className="cadidate-management-button big-icon"
                  // size=""

                  icon={<SearchOutlined />}
                  htmlType={"submit"}
                ></Button>
              </Form.Item>
            </Col>
          </Row>
        </Form>

        <FullCalendar
          ref={calendarRef}
          plugins={[dayGridPlugin, timeGridPlugin, interactionPlugin]}
          initialView="timeGridWeek"
          slotMinTime="00:00:00" // Thời gian bắt đầu
          slotMaxTime="23:59:59" // Thời gian kết thúc
          slotDuration="00:30:00" // Khoảng thời gian mỗi dòng
          allDaySlot={false} // Loại bỏ dòng "All Day"
          events={dataInterview}
          dayHeaderContent={(arg) => {
            if (arg.view.type === "dayGridMonth") {
              return arg.text.split(", ")[0]; // Khi view dạng Tháng, chỉ lấy phần "Thứ Hai" mà bỏ phần ngày/tháng "05/01"
            }
            return arg.text; // Giữ nguyên ở các chế độ khác
          }}
          headerToolbar={{
            left: "", // "prev,next today" toolbar  trái
            center: "", // "title" Toolbar ở giữa
            right:
              "prev,title,next,today,timeGridDay,timeGridWeek,dayGridMonth", // "timeGridDay,timeGridWeek,dayGridMonth" Toolbar phải
          }}
          locale={viLocale}
          slotLabelFormat={{
            hour: "2-digit",
            minute: "2-digit",
            meridiem: false, // Tắt AM/PM
          }}
          dayHeaderFormat={{
            weekday: "long", // Thứ viết tắt (ví dụ: "Th 2")
            day: "2-digit", // Ngày (ví dụ: "23")
            month: "2-digit", // Tháng (ví dụ: "12")
          }}
          dateClick={(info) => {
            handleOpenAddInterview(info);
          }}
          nowIndicator={true} // Thêm chỉ báo thời gian hiện tại
          eventClick={(info) => {
            handleOpenDetail(info);
          }}
          datesSet={(dateInfo) => {
            //  Khi ngày thay đổi

            onChangeTime(dateInfo);
          }}
        />
      </Spin>

      {isModalAddInterview && (
        <ModalAddInterview
          isModalAddInterview={isModalAddInterview}
          setIsModalAddInterview={setIsModalAddInterview}
          dateTimeSelect={dateTimeSelect}
          typeModal={typeModal}
          onFinishAddInterview={onFinishAddInterview}
          onFinishDelete={onFinishDelete}
          onFinishEdit={onFinishEdit}
          listUser={listUser}
          handleViewCVInterview={handleViewCVInterview}
        />
      )}
    </div>
  );
};

export default index;
